<template>
    <div>
        <div class="lg:hidden">
            <select-input
                v-model="selectedPackageId"
                name="packages"
                :options="packagesAsOptions"
                :placeholder="lang('Välj kanal','Select channel')"
                @input="changePackage"
            />
        </div>
        <div class="hidden lg:flex mb-2xl grid has-xs-gutter">
            <div
                v-for="tvPackage in packages"
                :key="tvPackage.id"
                class="column w-1/8 mb-sm"
            >
                <a
                    v-tooltip.top="tvPackage.name"
                    class="bg-white border-white product-tab py-md shadow-md hover:shadow-lg cursor-default"
                    @click="activePackage = tvPackage"
                >
                    <tv-simple-package-summary
                        :tv-package="tvPackage"
                        :use-image="true"
                    />
                    <div v-if="tvPackage.can_be_added_to_cart || cannotDeliver">
                        <add-to-cart-button
                            extra-class="lg:mt-md"
                            :article-class="tvPackage.article_class"
                            :article-id="tvPackage.article_id"
                            :disabled="cannotDeliver"
                            location="Extrakanaler"
                        >
                            {{ btnOrderText }}
                        </add-to-cart-button>
                    </div>
                </a>
            </div>
        </div>
        <div
            v-if="activePackage"
            class="card lg:hidden mb-xl"
        >
            <tv-simple-package-summary
                :tv-package="activePackage"
                :use-image="true"
            />
            <div v-if="activePackage.can_be_added_to_cart || cannotDeliver">
                <add-to-cart-button
                    extra-class="mt-lg"
                    :article-class="activePackage.article_class"
                    :article-id="activePackage.article_id"
                    :disabled="cannotDeliver"
                    location="Extrakanaler"
                >
                    {{ btnOrderText }}
                </add-to-cart-button>
            </div>
        </div>
    </div>
</template>

<script>
    import TvSimplePackageSummary from './Partials/TvSimplePackageSummary';

    export default {
        components: {
            TvSimplePackageSummary,
        },
        props: {
            packages: {
                type: Array,
                required: true,
            },
            packagesAsOptions: {
                type: Array,
                required: true,
            },
            cannotDeliver: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                activePackage: null,
                selectedPackageId: this.activePackage ? this.activePackage.id : '',
            };
        },
        computed: {
            btnOrderText() {
                return this.translation('services_blocks_btn_add_to_cart_short');
            },
        },
        methods: {
            changePackage(value) {
                this.activePackage = this.packages.find(tvPackage => tvPackage.id === value);
            },
        },
    };
</script>
